import React, { useState } from "react";

export default function CompleteModal({ show, onClose, customer, onSubmit, perHour, perDay }) {
  const [otherExpenses, setOtherExpenses] = useState("");
  const [addedAmount, setAddedAmount] = useState("");
  const [refundDescription, setRefundDescription] = useState("");
  const [refundAmount, setRefundAmount] = useState("");
  const [refundOpen, setRefundOpen] = useState(false);
  const [expensesOpen, setExpensesOpen] = useState(false);

  if (!show) return null;

  const original = Number(customer?.amount || 0);
  const refundNum = Number(refundAmount) || 0;
  const extraNum = Number(addedAmount) || 0;
  const finalAmount = (original - refundNum + extraNum).toFixed(2);

  return (
    <div className="modal-overlay" style={{ zIndex: 1002, background: "rgba(30,41,59,0.7)" }}>
      <div
        className="modal"
        style={{
          minWidth: 400,
          maxWidth: 480,
          maxHeight: "85vh",
          margin: "60px auto",
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(30,41,59,0.18)",
          padding: 32,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 18,
            right: 18,
            background: "#f1f5f9",
            border: "none",
            borderRadius: "50%",
            width: 32,
            height: 32,
            fontSize: 20,
            color: "#334155",
            cursor: "pointer"
          }}
          aria-label="Close"
        >
          ×
        </button>

        <div style={{ flex: 1, overflowY: "auto", paddingRight: 8 }}>
          <h2 style={{ marginBottom: 18, color: "#1e293b", fontWeight: 700, fontSize: 26 }}>Complete Booking</h2>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              marginBottom: 18,
              background: "#f8fafc",
              borderRadius: 10,
              padding: 16,
              boxShadow: "0 1px 4px rgba(30,41,59,0.04)"
            }}
          >
            <div style={{ fontSize: 17, marginBottom: 4 }}>
              <strong>Car:</strong> {customer?.car}
            </div>
            <div style={{ fontSize: 15, color: "#64748b", marginBottom: 4 }}>
              <strong>Duration:</strong> {customer?.totalDays?.toFixed(2) || 0} days ({customer?.totalHours?.toFixed(1) || 0} hrs)
            </div>
            <div style={{ fontSize: 15, color: "#64748b" }}>
              <span style={{ marginRight: 16 }}>
                <strong>Per Hour:</strong>{" "}
                <span style={{ color: "#0ea5e9" }}>₹{perHour}</span>
              </span>
              <span>
                <strong>Per Day:</strong>{" "}
                <span style={{ color: "#0ea5e9" }}>₹{perDay}</span>
              </span>
            </div>
            <div style={{ fontSize: 15, marginTop: 8, paddingTop: 8, borderTop: "1px solid #cbd5e1" }}>
              <strong>Original Amount:</strong>{" "}
              <span style={{ color: "#0ea5e9", fontSize: 16 }}>₹{original.toFixed(2)}</span>
            </div>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit({
                otherExpenses,
                addedAmount: extraNum,
                refundDescription,
                refundAmount: refundNum
              });
            }}
          >
            <div style={{ marginBottom: 18 }}>
              <button
                type="button"
                onClick={() => setExpensesOpen((r) => !r)}
                style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 12px", background: expensesOpen ? "#eef2ff" : "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 8, cursor: "pointer", fontWeight: 600, color: "#0f172a" }}
              >
                {expensesOpen ? "Hide Expenses" : "Add Expenses"}
                <span style={{ marginLeft: 6, opacity: 0.7 }}>{expensesOpen ? "▴" : "▾"}</span>
              </button>

              {expensesOpen && (
                <div style={{ marginTop: 12, display: "grid", gap: 12 }}>
                  <div>
                    <label style={{ fontWeight: 600, color: "#1e293b", display: "block", marginBottom: 6 }}>Other Expenses (Description)</label>
                    <input
                      type="text"
                      value={otherExpenses}
                      onChange={(e) => setOtherExpenses(e.target.value)}
                      style={{ width: "100%", padding: "10px 12px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 15, background: "#fff" }}
                      placeholder="E.g., Cleaning, Damage, Fuel, etc."
                    />
                  </div>

                  <div>
                    <label style={{ fontWeight: 600, color: "#1e293b", display: "block", marginBottom: 6 }}>Extra Expense Amount</label>
                    <input
                      type="number"
                      value={addedAmount}
                      onChange={(e) => setAddedAmount(e.target.value)}
                      style={{ width: "100%", padding: "10px 12px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 15, background: "#fff" }}
                      placeholder="Enter extra expense amount (₹)"
                      min={0}
                    />
                  </div>
                </div>
              )}
            </div>

            <div style={{ marginBottom: 18 }}>
              <button
                type="button"
                onClick={() => setRefundOpen((r) => !r)}
                style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 12px", background: refundOpen ? "#eef2ff" : "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 8, cursor: "pointer", fontWeight: 600, color: "#0f172a" }}
              >
                {refundOpen ? "Hide Refund" : "Refund Details"}
                <span style={{ marginLeft: 6, opacity: 0.7 }}>{refundOpen ? "▴" : "▾"}</span>
              </button>

              {refundOpen && (
                <div style={{ marginTop: 12, display: "grid", gap: 12 }}>
                  <div>
                    <label style={{ fontWeight: 600, color: "#1e293b", display: "block", marginBottom: 6 }}>Refund Description</label>
                    <input
                      type="text"
                      value={refundDescription}
                      onChange={(e) => setRefundDescription(e.target.value)}
                      style={{ width: "100%", padding: "10px 12px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 15, background: "#fff" }}
                      placeholder="E.g., Fuel, Security Deposit Refund, etc."
                    />
                  </div>

                  <div>
                    <label style={{ fontWeight: 600, color: "#1e293b", display: "block", marginBottom: 6 }}>Refund Amount</label>
                    <input
                      type="number"
                      value={refundAmount}
                      onChange={(e) => setRefundAmount(e.target.value)}
                      style={{ width: "100%", padding: "10px 12px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 15, background: "#fff" }}
                      placeholder="Enter refund amount (₹)"
                      min={0}
                    />
                  </div>
                </div>
              )}
            </div>

            <div style={{ background: "#f0f9ff", border: "1px solid #0ea5e9", borderRadius: 8, padding: 14, marginBottom: 20 }}>
              <div style={{ fontSize: 14, marginBottom: 8 }}>
                <strong>Original Amount:</strong>{" "}
                <span style={{ color: "#0ea5e9" }}>₹{original.toFixed(2)}</span>
              </div>

              {/* ADVANCE & PENDING DISPLAY */}
              {customer?.advanceAmount !== undefined && (
                <>
                  <div style={{ fontSize: 14, marginBottom: 8, color: "#22c55e", fontWeight: 600 }}>
                    <strong>Advance Paid:</strong>{" "}
                    <span style={{ color: "#22c55e" }}>₹{(customer.advanceAmount || 0).toFixed(2)}</span>
                  </div>
                  <div style={{ fontSize: 14, marginBottom: 8, color: "#f97316", fontWeight: 600 }}>
                    <strong>Pending at Booking:</strong>{" "}
                    <span style={{ color: "#f97316" }}>₹{(customer.pendingAmount || original).toFixed(2)}</span>
                  </div>
                </>
              )}

              {refundNum > 0 && (
                <div style={{ fontSize: 14, marginBottom: 8 }}>
                  <strong>Refund Amount:</strong>{" "}
                  <span style={{ color: "#ef4444" }}>-₹{refundNum.toFixed(2)}</span>
                </div>
              )}

              {extraNum > 0 && (
                <div style={{ fontSize: 14, marginBottom: 8 }}>
                  <strong>Extra Expense:</strong>{" "}
                  <span style={{ color: "#f97316" }}>+₹{extraNum.toFixed(2)}</span>
                </div>
              )}

              <div style={{ fontSize: 16, fontWeight: 700, paddingTop: 8, borderTop: "1px solid #0ea5e9", color: refundNum > 0 ? "#ef4444" : "#0ea5e9" }}>
                Final Amount: ₹{finalAmount}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 18 }}>
              <button type="button" onClick={onClose} style={{ padding: "8px 22px", background: "#f1f5f9", color: "#334155", border: "none", borderRadius: 6, fontWeight: 600, fontSize: 15, cursor: "pointer" }}>
                Cancel
              </button>

              <button type="submit" style={{ background: "#0ea5e9", color: "white", border: "none", borderRadius: 6, padding: "8px 28px", fontWeight: 700, fontSize: 16, boxShadow: "0 2px 8px rgba(14,165,233,0.08)", cursor: "pointer" }}>
                Complete
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
